jQuery(function ($) {
    const $body = $('body');

    // add to cart
    (function () {
        const $currentProduct = $('.product-section');
        const $addToCartArea = $('#multivariants');
        let $addToCartButton = null;

        if ($currentProduct.length && $addToCartArea.length) {
            init();
        }

        function init() {
            $addToCartButton = $('#multivariants_add_to_cart_button');

            if ($addToCartButton.length) {
                maybeChangeButtonTextToPreOrder();
            } else {
                maybeChangeButtonTextWhenButtonIsAvailable();
            }
        }

        function maybeChangeButtonTextWhenButtonIsAvailable() {
            const intervalId = setInterval(function () {
                $addToCartButton = $('#multivariants_add_to_cart_button');
                if ($addToCartButton.length) {
                    clearInterval(intervalId);
                    maybeChangeButtonTextToPreOrder();
                }
            }, 100);
        }

        function maybeChangeButtonTextToPreOrder() {
            if (!$currentProduct.data('is-pre-order')) {
                return;
            }

            $addToCartButton.text(theme.strings.preorder);
        }
    })();

    // header nav dropdowns
    (function () {
        const $triggers = $('[data-nav-drop-trigger]');

        $triggers.each((i, trigger) => {
            const $trigger = $(trigger), 
                $drop = $($trigger.data('nav-drop-trigger'));
            let showing = false;

            $trigger.on('click', e => {
                e.preventDefault();
                if(!showing) {
                    showDropdown();
                }
            });

            function showDropdown() {
                showing = true;
                $drop.show();

                setTimeout(setupClickoutsideCheck, 100);
            }

            function hideDropdown() {
                showing = false;
                $drop.hide();
                $(document).off('click.wb_drop');
            }

            function setupClickoutsideCheck() {
                $(document).on('click.wb_drop', e=>{
                    if(!$(e.target).closest($drop).length) {
                        hideDropdown($drop);
                    }
                })
            }
        });
    })();
    
    // announcement bar
    (function() {
        if(!$('.announcement-bar').length) {
            $('body').addClass('no-announcement-bar');
        }
    })();

    theme.CustomerDiscounts = (function() {
        const API_URL = 'https://b2b-shopify-common-api.web-bakery.de/discounts/';

        let discounts = [],
            $doc = $(document),
            $trigger = null,
            $count = null,
            $dropWrapper = null,
            isActive = false;

        function init() {
            initElements();

            if($trigger.length) {
                initEvents();

                loadDiscounts()
                    .then(syncView);
            }
        }

        function initElements() {
            $trigger = $('[data-discounts-popup-trigger]');
            $count = $trigger.find('.js-count');
            $dropWrapper = $trigger.find('.js-drop-wrapper');
        }

        function initEvents() {
            $trigger.find('button').on('click', togglePopup);
        }

        function togglePopup() {
            isActive ? hidePopup() : showPopup();
        }

        function showPopup() {
            isActive = true;
            $trigger.addClass('is-active');

            $doc.on('click.wb', (e) => {
                if(!$(e.target).closest($trigger).length) {
                    hidePopup();
                }
            });

            // close drawers
            $('body').trigger('productModalOpen');
        }

        function hidePopup() {
            isActive = false;
            $trigger.removeClass('is-active');

            $doc.off('click.wb');
        }

        function loadDiscounts() {
            return getDiscounts()
                .then(result => discounts = result);
        }

        function getDiscounts() {
            const data = {
                customerId: theme.customer.id,
                storeName: theme.settings.shopPermanentDomain,
            };

            return new Promise((resolve) => {
                return $.ajax({
                    method: 'GET',
                    url: API_URL,
                    data,
                })
                .then((resp) => {
                    resolve(resp.shareableUrls);
                }).catch((err) => {
                    resolve([]);
                });
            });
        }

        function syncView() {
            if(discounts.length) {
                $trigger.addClass('has-items');
            }
            
            $count.text(discounts.length);

            let template = Handlebars.compile(getDropTemplate());
            $dropWrapper.html(template({discounts}));
        }

        function getDropTemplate() {
            return `
            <div class="wb-drop wb-drop--v1 wb-drop--align-right">
                <div class="wb-drop__inner">
                    {{#if discounts}}
                        <ul class="wb-drop__list">
                            <li class="wb-drop__item wb-drop__item--title">{{t 'discounts.youHaveNDiscounts' count=discounts.length}}</li>
                            {{#each discounts}}
                            <li class="wb-drop__item wb-drop__item--link">
                                <a href="{{url}}">{{title}}</a>
                            </li>
                            {{/each}}
                        </ul>
                    {{else}}
                        <div class="wb-drop__empty">{{t 'discounts.noDiscounts'}}</div>
                    {{/if}}
                </div>
            </div>
            `;
        }

        init();
    })();

    // language switcher form
    (function () {
        class LanguageSwitcherV1 {
            constructor(elem) {
                this.$element = $(elem);
                this.$form = this.$element.find('form');
                this.$triggers = this.$form.find('ul a:not([aria-current=true])');
                this.$input = this.$form.find('input[name=locale_code]');

                this.$triggers.on('click', this.handleSubmit.bind(this));
            }

            handleSubmit(e) {
                e.preventDefault();
                const $trigger = $(e.target);
                this.$input.val($trigger.data('value'));
                this.$form.get(0).submit();
            }
        }

        const $elements = $('.lang-switcher--v1');

        $elements.each((i, elem) => new LanguageSwitcherV1(elem));
    })();
});